var ConfigurationType = /* @__PURE__ */ ((ConfigurationType2) => {
  ConfigurationType2["SEARCHES_CLUSTER_CONFIG"] = "org.graylog2.indexer.searches.SearchesClusterConfig";
  ConfigurationType2["MESSAGE_PROCESSORS_CONFIG"] = "org.graylog2.messageprocessors.MessageProcessorsConfig";
  ConfigurationType2["SIDECAR_CONFIG"] = "org.graylog.plugins.sidecar.system.SidecarConfiguration";
  ConfigurationType2["EVENTS_CONFIG"] = "org.graylog.events.configuration.EventsConfiguration";
  ConfigurationType2["INDEX_SETS_DEFAULTS_CONFIG"] = "org.graylog2.configuration.IndexSetsDefaultConfiguration";
  ConfigurationType2["URL_ALLOWLIST_CONFIG"] = "org.graylog2.system.urlallowlist.UrlAllowlist";
  ConfigurationType2["PERMISSIONS_CONFIG"] = "org.graylog2.users.UserAndTeamsConfig";
  ConfigurationType2["USER_CONFIG"] = "org.graylog2.users.UserConfiguration";
  ConfigurationType2["PASSWORD_COMPLEXITY_CONFIG"] = "org.graylog2.users.PasswordComplexityConfig";
  ConfigurationType2["CERTIFICATE_RENEWAL_POLICY_CONFIG"] = "org.graylog2.plugin.certificates.RenewalPolicy";
  ConfigurationType2["GLOBAL_PROCESSING_RULE_CONFIG"] = "org.graylog2.shared.buffers.processors.TimeStampConfig";
  ConfigurationType2["MCP_CONFIG"] = "org.graylog.mcp.config.McpConfiguration";
  ConfigurationType2["MARKDOWN_CONFIG"] = "org.graylog2.configuration.MarkdownConfiguration";
  return ConfigurationType2;
})(ConfigurationType || {});
export default ConfigurationType;
export { ConfigurationType };
